import { render, staticRenderFns } from "./UtilDivider.vue?vue&type=template&id=1b1bc367&scoped=true&"
import script from "./UtilDivider.vue?vue&type=script&lang=js&"
export * from "./UtilDivider.vue?vue&type=script&lang=js&"
import style0 from "./UtilDivider.vue?vue&type=style&index=0&id=1b1bc367&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1bc367",
  null
  
)

export default component.exports